export const BadgesListStyle = {
  container: {
    "& > div": {
      margin: "5px",
    },
    display: "flex",
  },
};
